import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  primary?: boolean;
  size?: 'small' | 'medium' | 'large';
  onClick?: () => void;
  className?: string;
}
export const Button = ({
  children,
  primary = true,
  size = 'medium',
  onClick,
  className = ''
}: ButtonProps) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-full transition-all duration-300';
  const sizeStyles = {
    small: 'px-4 py-2 text-sm',
    medium: 'px-6 py-3 text-base',
    large: 'px-8 py-4 text-lg'
  };
  const colorStyles = primary ? 'bg-[#00b8c4] text-white hover:bg-[#00a0aa] active:bg-[#008e98] shadow-lg hover:shadow-xl' : 'bg-[#ffcc29] text-gray-800 hover:bg-[#ffc300] active:bg-[#ffb700] shadow-md hover:shadow-lg';
  return <button onClick={onClick} className={`${baseStyles} ${sizeStyles[size]} ${colorStyles} ${className}`} data-id="element-39">
      {children}
    </button>;
};